import { useCallback } from 'react';
import cn from 'clsx';
import { useLipaPortfolioTrackButtonClick } from '@pkgs/components/hooks/useLipaPortfolioTrackButtonClick';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useMapStore } from '@pkgs/components/hooks/stores/useMapStore';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { usePlaceDetails } from '@pkgs/components/hooks/queries/usePlaceDetails';
import { MAXIMUM_MAP_BBOX } from '@pkgs/components/consts/map';
import { GLOBAL_NETWORK_IMAGE_URL } from '@pkgs/components/consts/consts';
import { Button } from '@ev-tech/ui-core-components/Button';
import { UserActionEnum } from '@ev-tech/snowplow-library';

import styles from './LipaCtaCard.module.css';

export const LipaCtaCard = ({ className }: { className?: string }) => {
  const { t, ImageComponent } = useAppContext();
  const resetShopState = useSearchStore((state) => state.resetShopState);
  const placeIds = useSearchStore((state) => state.placeIds);
  const { combinedBoundingBox } = usePlaceDetails();

  const { trackButtonClick } = useLipaPortfolioTrackButtonClick({
    elementId: 'property-card_search-all-primary',
    action: UserActionEnum.click,
  });
  const updateMapBounds = useMapStore((state) => state.updateMapBounds);

  const handleButtonClick = useCallback(() => {
    trackButtonClick();
    resetShopState();
    if (placeIds?.length && combinedBoundingBox) {
      updateMapBounds(combinedBoundingBox);
    } else {
      updateMapBounds(MAXIMUM_MAP_BBOX);
    }
  }, [trackButtonClick, resetShopState, updateMapBounds, placeIds, combinedBoundingBox]);

  return (
    <article className={cn(styles.container, className)} data-testid="search-components_lipa-cta-card">
      <div className={styles.imageContainer}>
        <ImageComponent
          src={GLOBAL_NETWORK_IMAGE_URL}
          alt="display showing engel and voelkers global network"
          height={240}
          width={360}
          className={styles.image}
        />
      </div>

      <div className={styles.content}>
        <span className={styles.title}>{t('search.licencePartner.ctaCard.text')}</span>
        <Button className={styles.button} type="button" label={t('search.licencePartner.ctaCard.buttonText')} onClick={handleButtonClick} />
      </div>
    </article>
  );
};
